<script lang="ts">
  import Confirmation from '../Confirmation/Component.svelte'
  import type { Component, ComponentProps } from '../utilities/typeHelpers'
  import { getContext } from 'svelte'
  import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
  import Fa from 'svelte-fa'
  import { delete_results_on_date } from './Results'
  export let date: string

  const {
    open,
  }: {
    open: (component: Component<Confirmation>, props: ComponentProps<Confirmation>) => void
  } = getContext('simple-modal')

  const showDeleteDates = () =>
    open(Confirmation as unknown as Component<Confirmation>, {
      message: `Are you sure you want to delete all the results from the retro held on ${date}?`,
      action: () => $delete_results_on_date(date),
    })
</script>

<!-- TODO remove this comment and fix -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="delete-icon tooltip" on:click={showDeleteDates}>
  <Fa color="var(--tsf-red)" icon={faTimesCircle} />
  <div class="tooltip-text">Delete all results on this day.</div>
</div>

<style>
  .delete-icon {
    cursor: pointer;
    align-self: center;
  }

  .tooltip {
    position: relative;
  }

  .tooltip .tooltip-text {
    --width: 7em;
    width: var(--width);
    background-color: var(--tsf-black);
    color: var(--tsf-white);
    text-align: center;
    border-radius: 1em;
    padding: 0.5em;
    position: absolute;
    left: calc(-1 * var(--width) / 2);
    z-index: 1;
    opacity: 0;
  }

  .tooltip:hover .tooltip-text {
    opacity: 1;
    transition: opacity 0.5s;
  }
</style>
